import { useWizardStepsStore } from "../store/wizardStepsStore";

export const useWizardStepsService = () => {
  const currentPage = document.getElementById("currentPage") as HTMLInputElement;
  const currentLanguage = document.getElementById("currentLanguage") as HTMLInputElement;

  const getPageTree = async () => {
    const store = useWizardStepsStore();
    store.loading = true;

    fetch(`/api/WizardStepsApi/${currentPage.value}/${currentLanguage.value}`, {
      method: "GET",
      headers: {
        "Content-Type": "text/html",
        Accept: "text/html",
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      response.json().then((data: Step) => {
        store.steps = data;
        store.currentStep = data.subItems[0];
      });
      
    })
    .catch((error) => {
      store.error = true;
    })
    .finally(() => {
      store.loading = false;
    });
  };

  return {
    getPageTree,
  };
};